export interface IdTextType
{
    value: string;
    label: string;
}
export interface ShellType
{
    title: string;
}
export enum EnumAppMode
{
    unset = 0,
    NotTeams = 1,
    Teams = 2
}
